import React from "react";
import { Text, Tooltip } from "@chakra-ui/react";

import { useConfigurationThemeConsumer } from "ChakraTheme";

import { IconButton } from "components/IconButton";

const MediumLettersButton = () => {
  const { dispatch } = useConfigurationThemeConsumer();
  const mediumLetterSizeMessage = "Duża wielkość liter";
  return (
    <Tooltip
      label={mediumLetterSizeMessage}
      aria-label={mediumLetterSizeMessage}
    >
      <IconButton
        id="medium-letters-btn"
        aria-label={mediumLetterSizeMessage}
        background="transparent"
        size="lg"
        icon={<Text fontSize="lg">A+</Text>}
        onClick={() => dispatch({ type: "FONT_SIZE_BIG" })}
      />
    </Tooltip>
  );
};

export { MediumLettersButton };
